export default "data:application/font-woff;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAicHJveGltYW5vdmEtdGhpbi13ZWJmb250LndvZmYiOw=="